/**
 * interact.js 1.10.26
 *
 * Copyright (c) 2012-present Taye Adeyemi <dev@taye.me>
 * Released under the MIT License.
 * https://raw.github.com/taye/interact.js/main/LICENSE
 */

import autoScrollPlugin from './plugin.js';
import interact from "../interact/index.js";
import "../utils/domUtils.js";
import "../utils/is.js";
import "../utils/raf.js";
import "../utils/rect.js";
import "../utils/window.js";

/* eslint-disable no-console, eol-last, import/no-duplicates,  import/no-extraneous-dependencies, import/order */
interact.use(autoScrollPlugin);
//# sourceMappingURL=index.js.map
